import {IRoutesProvider, RoutesType} from 'Shared/Routes';
import { loginRoutes } from 'Shared/routes/LoginRoutes';
import { lazy } from 'solid-js';
import {GeneralRedirect} from 'Shared/Routes';


export class VenueRoutes implements IRoutesProvider
{
	routes(): RoutesType
	{
//TODO add redirect route for all trailing /s here. Currently a hack is fixed in Server.resolveRoute()

		return ({
			...this.frontend(),
			...this.backend(),

//TODO want a frontend page not found page. Doing this prevents '/logout' (and probably other routes from reaching the server router though).
//     Could possibly render and call the page not found page directly from the Server.ts file
//			'/*':	[new FrontendPageNotFound(this.inBrowser,this.urls,this.times),() => ({}) ],
		});
	}

	frontend()
	{
		return ({
			'/':					lazy(() => import('Shared/frontend/homePage/HomePage')),
			'/menu':				lazy(() => import('Shared/frontend/menuPage/MenuPage')),  //TODO slug: 'menu'
			'/events':				lazy(() => import('Shared/frontend/eventsPage/EventsPage')),
			'/event/:slug':			lazy(() => import('Shared/frontend/eventPage/EventPage')),
			'/event/:slug/artist':	lazy(() => import('Shared/frontend/eventPage/ArtistAgreementPage')),
			'/contact':				lazy(() => import('Shared/frontend/contactPage/ContactPage')),
			'/hire':				lazy(() => import('Shared/frontend/hirePage/HirePage')),
			'/reservation':			lazy(() => import('Shared/frontend/reservationPage/ReservationPage')),
			'/hire-enquiry':		lazy(() => import('Shared/frontend/hireEnquiryPage/HireEnquiryPage')),
			'/staffResources':		lazy(() => import('Shared/frontend/staffResources/StaffResourcePage')),
		}) as RoutesType;
	}

	backend()
	{
		return ({
			...this.backendEvents(),
			...this.backendMenu(),
			...this.backendSpecials(),

			...loginRoutes(),

			'/login': 					() => <GeneralRedirect url='/admin'/>,

			'/admin':					lazy(() => import('Shared/backend/DashboardPage')),
			'/admin/home': 				lazy(() => import('Shared/backend/homePage/HomePage')),
			'/admin/home/:tab': 		lazy(() => import('Shared/backend/homePage/HomePage')),
			'/admin/hire': 				lazy(() => import('Shared/backend/hire/HirePage')),
			'/admin/hire/:tab':			lazy(() => import('Shared/backend/hire/HirePage')),
			'/admin/contact': 			lazy(() => import('Shared/backend/contact/ContactPage')),
			'/admin/contact/:tab':		lazy(() => import('Shared/backend/contact/ContactPage')),
			'/admin/staffResources':	lazy(() => import('Shared/backend/staffResources/StaffResourcesPage')),
			'/admin/staffResource/:id':	lazy(() => import('Shared/backend/staffResources/StaffResourcePage')),
			'/admin/settings': 			lazy(() => import('Shared/backend/settingsPage/SettingsPage')),

//TODO return 404			
			'/admin/*':					lazy(() => import('Shared/backend/PageNotFoundPage')),

		}) as RoutesType;
	}

	backendEvents()
	{
//TODO combine multiple event/... into single array: Solid Router will treat as the same page		
		return ({
			'/admin/events':									lazy(() => import('Shared/backend/eventsPage/EventsPage')),
			'/admin/event/:slug':								lazy(() => import('Shared/backend/eventPage/EventPage')),
			'/admin/event/:slug/:topTab':						lazy(() => import('Shared/backend/eventPage/EventPage')),
			'/admin/event/:slug/:topTab/:secondTab':			lazy(() => import('Shared/backend/eventPage/EventPage')),
			'/admin/event/:slug/:topTab/:secondTab/:thirdTab':	lazy(() => import('Shared/backend/eventPage/EventPage')),

		}) as RoutesType;
	}

	backendMenu()
	{
		return ({
			'/admin/listMenu/:slug': 				lazy(() => import('Shared/backend/menu/ListMenuPage')),

			'/admin/menus': 						lazy(() => import('Shared/backend/menu/MenusPage')),
			'/admin/menu-designer': 				lazy(() => import('Shared/backend/menu/MenuDesignerPage')),

			/* Unclassified items: */
			'/admin/menus/:slug':					lazy(() => import('Shared/backend/menu/SectionPage')),
			'/admin/menus/:slug/*sectionIds':		lazy(() => import('Shared/backend/menu/SectionPage')),
			'/admin/menu-item/:slug/*sectionIds':	lazy(() => import('Shared/backend/menu/MenuItemPage')),
		}) as RoutesType;
	}

	backendSpecials()
	{
		return ({
			'/admin/specials': 		lazy(() => import('Shared/backend/specials/SpecialsPage')),
			'/admin/special/:id':	lazy(() => import('Shared/backend/specials/SpecialPage')),
		}) as RoutesType;
	}

/*
	navDemos()
	{
		return <RoutesType>({
			'/navDemos': 										Nav.index,
			'/navDemos/homepageExample1':						Nav.homepageExample1,
			'/navDemos/homepageExample2':						Nav.homepageExample2,
			'/navDemos/logoToSideOfTitleAndNav':				Nav.logoToSideOfTitleAndNav,
			'/navDemos/logoToSideOfTitleAndNavCollapsed':		Nav.logoToSideOfTitleAndNavCollapsed,
			'/navDemos/shrinkingNavOverflowingLogo':			Nav.shrinkingNavOverflowingLogo,
			'/navDemos/shrinkingNavOverflowingLogoCollapsed':	Nav.shrinkingNavWithLogoCollapsed,
			'/navDemos/shrinkingNavWithLogo':					Nav.shrinkingNavWithLogo,
			'/navDemos/shrinkingNavWithLogoCollapsed':			Nav.shrinkingNavWithLogoCollapsed,
			'/navDemos/stickyNavOnParallaxBanner':				Nav.stickyNavOnParallaxBanner,
			'/navDemos/stickyNavOnParallaxBannerCollapsed':		Nav.stickyNavOnParallaxBannerCollapsed,
		});
	}
*/
}

export function extractMenuSectionIds(sectionsIds?:string)
{
	if (!sectionsIds)
		return [];

	const parts = [];
	for (const bit of sectionsIds.split('/')) {
		const segments = bit.split('-');
		parts.push({name:segments[0],index:Number(segments[1])});
	}
	return parts;
}

